import { ModalProvider, themeBaseLight } from '@cmctechnology/phoenix-stockbroking-web-design';
import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { BusinessRegion } from './configuration/configuration';
import { BusinessRegionProvider } from './hooks/useBusinessRegion';
import { BusinessRegionRoutes } from './routes/BusinessRegionRoutes';
import { Store } from './Store/Store';
import { loadThirdPartyScripts } from './utils/scriptLoader';

export const App: React.FC = () => {
  useEffect(() => {
    // Load third-party scripts (TTD pixel, etc.) after component mounts
    loadThirdPartyScripts({ async: true }).catch(() => {
      // Silently catch and ignore errors, particularly for E2E tests where scripts are blocked.
    });
  }, []);

  return (
    <Provider store={Store}>
      <ThemeProvider theme={themeBaseLight}>
        <HelmetProvider>
          <ModalProvider />
          <BusinessRegionProvider defaultBusinessRegion={BusinessRegion.AUS}>
            <BrowserRouter>
              <BusinessRegionRoutes />
            </BrowserRouter>
          </BusinessRegionProvider>
        </HelmetProvider>
      </ThemeProvider>
    </Provider>
  );
};
